import React from 'react';
import ReactDOM from 'react-dom';
import FormModuleLookup from '../components/FormModuleLookup';

import FormItemEditor from './FormItemEditor';
import ControlPropertyConst from './controlproperty/ControlPropertyConst';
import LookupReturnStore from '../stores/LookupReturnStore';
import {LookupDropDownCloseStore} from '../stores/LookupStores';
import LookupActions from '../actions/LookupActions';
import {RecordFieldChangeStore,RecordNextStore,RecordPrevStore,AutoSaveBeforeStore} from '../stores/RecordsStore';
import RecordsActions from '../actions/RecordsActions';
import FocusActions from '../actions/FocusActions';
import UtilActions from '../actions/UtilActions';
import FormItemConst from './FormItemConst';
import AjaxRemoteUtil from '../utils/AjaxRemoteUtil';
import FormItemUtil from '../utils/FormItemUtil';
import StringUtil from '../utils/StringUtil';
import GOTUtil from '../utils/GOTUtil';
import RecordsUtil from '../utils/RecordsUtil';
import ToolBarUtil from '../utils/ToolBarUtil';
import FormResourceUtil from '../utils/FormResourceUtil';
import FormLookupFactory from '../utils/FormLookupFactory';
import CommandResolver from '../utils/CommandResolver';
import CommonUtil from '../utils/CommonUtil';
import Warning from '../utils/Warn';
import Cmd from '../forms/sys/remote/Cmd';
import ServiceHelper from '../remote/ServiceHelper';
import CommandHelper from '../remote/CommandHelper';
import Command from '../remote/Command';

import EditorFormType from '../utils/EditorFormType';

import LayerManager from '../manager/LayerManager';


import {UpdateDropDownContentStore} from '../stores/CmdTypeStore';
import FormItemStringResolver from './resolver/FormItemStringResolver';
import FormDataSources from '../datasource/FormDataSources';
import CommandActions from '../actions/CommandActions';
import { i } from 'react/lib/ReactDOMFactories';
import GOT from '../utils/GOT';


//import ItemEditorMix from './ItemEditorCacheInputMix';

export default class FormItemStringEditor extends FormItemEditor
{
	constructor(props) {
		super(props);
		this.initMembers();
		this.initStores();
		this.hasLookup = true;
		this.classAlias = "FormItemStringEditor";
		this.state.imeEnabel = true;
		this.state.nullValue = false;
		this.state.dropDownNumKeyBoard = this.props.dropDownNumKeyBoard || this.props.control.dropDownNumKeyBoard || this.props.control.getProperty_DropDownContent();
	}


	initMembers()
	{
		this.lookupEvents = [
			[$(document), {
				'mousedown touchstart': $.proxy(function(e){					
					if (!(
						$(this.inputgroup).is(e.target) ||
						$(this.inputgroup).find(e.target).length ||
						this.lookupStates.dropdownform.is(e.target) ||
						this.lookupStates.dropdownform.find(e.target).length ||
						$(".datepicker.datepicker-dropdown").find(e.target).length
					)){
						this.closeDropDown();
					}
				}, this)
			}]
		];
		this.toolBarObject = ToolBarUtil.createToolBarObj_Form_FormLookup();
	}

	initStores()
	{
		if(!this.props.forLookup)
		{
			this.unsubscribeLookupReturnStore = LookupReturnStore.listen(this.onLookupReturn.bind(this));
			//this.unsubscribeLookupCmpStore = LookupCmpStore.listen(this.onLookupCmp.bind(this));
			this.unsubscribeRecordFieldChangeStore = RecordFieldChangeStore.listen(this.onDataFieldChanged.bind(this));
			this.unsubscribeRecordNextStore = RecordNextStore.listen(this.onRecordNext.bind(this));
			this.unsubscribeRecordPrevStore = RecordPrevStore.listen(this.onRecordPrev.bind(this));
			this.unsubscribeAutoSaveBeforeStore = AutoSaveBeforeStore.listen(this.onBeforeAutoSave.bind(this));
			this.unsubscribeLookupDropDownCloseStore = LookupDropDownCloseStore.listen(this.onLookupDropDownClose.bind(this));

			this.unsubscribeUpdateDropDownContenStore = UpdateDropDownContentStore.listen(this.onUpdateDropDownContnent.bind(this));
		}
	}

	componentWillUnmount()
	{
		this.distroyCommonStores();
		//alert("FormItemStringEditor 卸载");
		if(!this.props.forLookup)
		{
			this.unsubscribeLookupReturnStore();
			this.unsubscribeRecordFieldChangeStore();
			this.unsubscribeRecordNextStore();
			this.unsubscribeRecordPrevStore();
			this.unsubscribeAutoSaveBeforeStore();
			this.unsubscribeLookupDropDownCloseStore();
			this.closeDropDown();
			let lookupdiv = this.lookupStates.dropdownform;

			if(lookupdiv)
			{
				ReactDOM.unmountComponentAtNode(lookupdiv.get(0));
				lookupdiv.remove();
			}
			this.unsubscribeUpdateDropDownContenStore();
		}
		
	}

	lookupStates = 
	{
		isShowed:false,
		dropdownform:null,
		lookup:null
	}

	onUpdateDropDownContnent(type,control,formModuleInstanceuuId)
	{
		if(this.props.moduleInstanceId == formModuleInstanceuuId && control == this.props.xml.name)
		{
			if(type == "NumKeyBoard")
			{
				this.setState({dropDownNumKeyBoard:true});
			}
			else if(type == "normal")
			{
				this.setState({dropDownNumKeyBoard:false});
			}
		}
		
	}

	onRecordNext()
	{
		if(this.lookupStates.isShowed)
		{
			LookupActions.lookupHostKeydown(this.lookupKey,{keyCode:40,key:"ArrowDown"});
		}
	  	//alert('formLookup');
	}

	onRecordPrev()
	{
		if(this.lookupStates.isShowed)
		{
			LookupActions.lookupHostKeydown(this.lookupKey,{keyCode:38,key:"ArrowUp"});
		}
	}

	onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId)
	{
		super.onCurrentRecordChanged(records,currentRecord,groupAlias,moduleInstanceId);
		if(this.props.groupAlias == groupAlias && this.props.moduleInstanceId == moduleInstanceId)
		{
			this.currentDataFieldChanged = false;			
			this.doSetModifiedTagNone();
			if(this.props.dataField)
			{
				var _value = (this.record!=null&&this.record!=undefined)?this.record[this.props.dataField]:'';
			}
			else
			{
				_value = this.record;
			}
			//var _value = (this.record!=null&&this.record!=undefined&&this.props.dataField)?this.record[this.props.dataField]:"";
			$(this.inputField).val(_value);
			if(this.props.control)
			{
				var _allowEdit = true;
				if(!this.record && groupAlias)
				{
					_allowEdit = false;
				}
				else
				{
					_allowEdit = this.props.control.getProperty_AllowEdit_Final(this.record);
				}
				this.doSetEnable(_allowEdit);	
			}
			
		}
	}

	onDataFieldChanged(record,dataField,oldValue,newValue,observer)
	{
		if(observer != this && this.props.dataField == dataField && record == this.record)
		{
			this.setDisplay(newValue);
			this.updateModifiedTag();
		}
	}

	//目前测试下来 react生命周期方法只有在超类显式定义才可以调用super
	componentDidMount()
	{	
		super.componentDidMount();
		
		if(this.props.underQueryGroup)
		{

			this.doSetEnable(false);
			
		}
		else
		{
			this.onCurrentRecordChanged(null,this.props.initRecord,this.props.groupAlias,this.props.moduleInstanceId);
		}
		
		this.checkDropDownHas();
		$(this.element).contextPopup(this.props.contextMenuData);

		if(this.props.initEditorValue && !this.props.dataField)
		{
			this.setFinalValue(this.props.initEditorValue,false);
			this.setDisplay();
		}
		this.initToolTip();

		if(this.inputField && typeof(this.props.allowKeyIn)=="boolean" && this.props.allowKeyIn == false)
		{
			let _inputField = this.inputField;
			$(this.inputField).keyup(function(){
				if(_inputField.value)
					_inputField.value = _inputField.value.replace(/[\W]/g,'')
			});
		}
	}

	initToolTip()
	{
		//alert(232);
		//return;
		let self = this;
		$(this.inputField).poshytip({

			className: 'tip-yellowsimple',
			//showOn: 'focus',
			dontOverwriteOption:true,//由于每次content都需要一个固定函数 所以修改源代码加入该配置
			alignTo: 'target',
			alignX: 'inner-left',
			alignY: 'bottom',
			offsetX: 0,
			offsetY: 5,
			ctrlKeyActive: false,
			content:function(callBackFunc){self.remoteCallToolTip(callBackFunc)},//"[title]"
			showTimeout: 500

		});
	}

	remoteCallToolTip(callBackFunc)
	{
		
		var mi;
		let command;let commandArg;
		if(!this.props.control.group)
		{
			let result = LayerManager.executeLayerMethod(this.props.control.module,this.props.control.group,"dataTip_"+this.props.xml.name);
			if(result)
			{
				setTimeout(function(){callBackFunc(result);},100);
				return;
			}

			mi = FormResourceUtil.getCommandArgMethodInfo("dataTip_"+this.props.xml.name,window.menuItemId,window.formId);		
			command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doDataTip", "String");
			commandArg = CommandResolver.getSendCmd(this.props.control.module, this.props.groupAlias, mi);
			command.appendArg(null, "String")
			.appendArg(this.props.xml.name, "String")
			.appendArg(commandArg, "CommandArg");
		}
		else
		{
			let result = LayerManager.executeLayerMethod(this.props.control.module,this.props.control.group,"dataTip_"+this.props.xml.name);
			if(result)
			{
				setTimeout(function(){callBackFunc(result);},100);
				return;
			}
			var _methodName = this.props.dataField;
			if(!_methodName)
				return;
			
			_methodName = _methodName.substr(_methodName.indexOf(".")+1);
			let _fieldName = _methodName;
			_fieldName = StringUtil.convertToEachFirstUpperCase(_fieldName);
			_methodName = StringUtil.convertToEachFirstUpperCase(_methodName);
			_methodName = StringUtil.replaceAll(_methodName, ".", "_");
			mi = FormResourceUtil.getCommandArgMethodInfo(this.props.groupAlias+".dataTip_"+_methodName,window.menuItemId,window.formId);
			command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doDataTip", "String");
			commandArg = CommandResolver.getSendCmd(this.props.control.module, this.props.groupAlias, mi);
			command.appendArg(this.props.groupAlias, "String")
			.appendArg(_fieldName, "String")
			.appendArg(commandArg, "CommandArg");
		}
		
		var remoteArg = {command:command,sync:false,
			resultFunction:function(data)
			{
				//alert(JSON.stringify(data));
				if(data.result){
					callBackFunc(data.result);
				}
			}
		};
		if(window.isDataSetView){
			return;
		}
		if((this.props.control.group && this.props.control.group.forLookup) || this.props.forLookup){
			return;
		}
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	checkDropDownHas()
	{
		//如果是下拉框 则一定无
		if(this.props.forLookup)
		{
			$(this.downArrowButton).hide();
			this.hasLookup = false;return;
		}
		if(this.props.control.serverHasLookup == null || this.props.control.serverHasLookup == undefined)
		{
			if(this.props.serverSpecify)	
				return;
			if(window.isDataSetView)return;
			var base = this.getLookupBase();
			if(!FormLookupFactory.hasFormLookup(base, this.props.formId, this.props.group))//如果GOT没有 则设置为false
			{	
				$(this.downArrowButton).hide();this.hasLookup = false;
			}
		}
		else //update指定是否显示
		{
			if(this.props.control.serverHasLookup == false)
			{
				$(this.downArrowButton).hide();this.hasLookup = false;
			}
		}
			
	}

	doSetEnable(enable)
	{
		this.setState({allowEdit:enable});
		/*var nowAllowEdit = $(this.inputField).attr("readonly")==undefined;
		if(nowAllowEdit == true && enable == false)
		{
			this.setState({allowEdit:false});
		}
		else if(nowAllowEdit == false && enable == true)
		{
			this.setState({allowEdit:true});
		}*/
	}
	
	doMutiFieldReturn(returnFields)
	{
		var v = null;
		for(let i = 0;i<returnFields.length;i++)
		{
			var flrf = returnFields[i];
			if(flrf.fromValue != null && flrf.fromValue != undefined)
			{
				if(this.props.groupAlias=="" || !this.props.groupAlias)
				{
					var value = flrf.fromValue;
					
					var editorName = flrf.toDataField;
					if(editorName != this.props.xml.name)
					{
						LookupActions.lookupReturnMutiEditor(editorName,value);
						//$(this.inputField).focus();$(this.inputField).select();
					}
					else
					{
						v = value;
					}
					continue;
				}
				var _to = this.props.groupAlias+"."+StringUtil.convertToEachFirstLowerCase(flrf.toDataField);	
				var toRecord = this.props.rowData?this.props.rowData:this.record;
				if(!toRecord.hasOwnProperty(_to))
				{
					Warning.show({text:"当前记录中不含"+_to+"  请检查lookupSelect二次开发方法"});
					continue;
				}
				if(this.props.dataField == _to)
				{
					v = flrf.fromValue;
					//$(this.inputField).val(flrf.fromValue);
				}
				else
				{
					toRecord[_to] = flrf.fromValue;
				}
				
			}
		}
		return v;
		
	}
	
	doMutiFieldReturn1(returnFieldsMap)
	{
		if(this.props.groupAlias == "" || !this.props.groupAlias)
			return null;
		var toRecord = this.props.rowData?this.props.rowData:this.record;
		var v = null;
		for(var _dataField in returnFieldsMap)
		{
			var _to = this.props.groupAlias+"."+StringUtil.convertToEachFirstLowerCase(_dataField);
			if(!toRecord.hasOwnProperty(_to))
			{
				alert("当前记录中不含"+_to+"  请检查lookupSelect二次开发方法");
				continue;
			}
			if(this.props.dataField == _to)
			{
				v = flrf.fromValue;
				//$(this.inputField).val(flrf.fromValue);
			}
			else
			{
				toRecord[_to] = flrf.fromValue;
			}
		}
		return v;
	}

	onLookupReturn(value,entityId,innerId)
	{
		if(this.props.formId == entityId && this.props.xml.id == innerId)
		{
			if(Array.isArray(value) == true)
			{
				value = this.doMutiFieldReturn(value);
			}
			else if(typeof(value) == "object")
			{
				value = this.doMutiFieldReturn1(value);
			}
			
			
			// if(this.lookupStates.isShowed)
			// {
				//lookupdiv.remove();
				//this.lookupStates.isShowed = false;
				let _replace = (this.props.returnLookup == "Replace");
				if(_replace)
				{
					this.closeDropDown();
					this.onLookupReturning = true;
					this.setFinalValue(value);
					//todo 值回送数据完成以后 严格按照显示要求再进行显示
					this.setDisplay();

					this.inputField.focus();
					
					this.inputField.select();
				}
				else
				{
					this.onLookupReturning = true;
					let $t = this.inputField;
					if ($t.selectionStart || $t.selectionStart == '0') {
						var startPos = $t.selectionStart;
						var endPos = $t.selectionEnd;
						var scrollTop = $t.scrollTop;
						$t.value = $t.value.substring(0, startPos) + value + $t.value.substring(endPos, $t.value.length);
						this.inputField.focus();
						$t.selectionStart = startPos + value.length;
						$t.selectionEnd = startPos + value.length;
						$t.scrollTop = scrollTop;
					}
					else {
						this.inputField.value += value;
						this.inputField.focus();
					}
					this.closeDropDown();
				}
				

				this.onLookupReturning = false;
				
				// $(this.inputField).val(value);
				return false;
			// }
		}
	}

	onLookupCmp()
	{
		var lookupdiv = this.lookupStates.dropdownform;
		var _inputwidth = $(this.inputgroup).width();//this.props.displayLengthWidth;
		var _iframewidth = lookupdiv.outerWidth();
		
		var _iframeheight = lookupdiv.outerHeight();
		
		var _gwidth = $("#app").width();
		var _gheight = $("#app").height();

		if(_iframewidth>_gwidth)
		{
			_iframewidth = _gwidth;
			lookupdiv.css({width:_iframewidth+'px',overflow:"auto"});
		}
		var _offset = $(this.inputgroup).offset();
		var _y = _offset.top; 
		var _x = _offset.left;
		var _top = _y+$(this.inputgroup).height();
		//alert('x:'+_x+'y:'+_y);
		//下方屏幕放不下
		if((_top+_iframeheight)>_gheight)
		{
			//上下都放不下 考虑缩减高度
			if(_iframeheight>_y)
			{
				//上方空间大
				if(_y>(_gheight/2))
				{
					let _newdivheight = (_y-1)+'px';
					//lookupdiv.css("height":_newdivheight);
					lookupdiv.height(_y-2);
					//alert(_newdivheight);
					_top = '0px';
					//'-'+_newdivheight+'px';

				}
				else //下方空间大
				{
					//let _newdivheight = (_gheight-_y)+'px';
					lookupdiv.css("height",(_gheight-_top)+'px');	
				}
			}
			else//下拉框置于上方
			{
				_top = (_y-_iframeheight)+'px';
					//'-'+_iframeheight+'px';
			}
		}
		var _left = _x-((_iframewidth-_inputwidth)/2);
			//(_iframewidth-_inputwidth)/2;
		if(_left+_iframewidth>_gwidth)
			_left = _gwidth-_iframewidth-5;
		if(_left<0)_left = 0;
		
		lookupdiv.css({left:(_left+'px'),top:_top});
		//lookupdiv.css({left:'860px',top:'200px'});
		
		this.lookupStates.isShowed = true;
	}

	closeDropDown()
	{
		if(this.lookupStates.isShowed)
		{

			if(this.lookupStates.lookup && this.lookupStates.lookup.beforeClose && typeof(this.lookupStates.lookup.beforeClose) == "function")
			{
				this.lookupStates.lookup.beforeClose();
			}

			let lookupdiv = this.lookupStates.dropdownform;
			if(lookupdiv == null)
				return;
			this.detachEventListeners();
			
			// lookupdiv.remove();
			lookupdiv.css("display","none");
			this.moduleLookup = null;
			
			this.lookupStates.isShowed = false;
			
			//this.refs.inputdom.focus();this.refs.inputdom.select();
			this.inputField.focus();
			this.inputField.select();

			window.lookupShowing = false;
			window.nowLookupInstance = null;
			window.toolBarObject = Object.assign({},this.dropDownBakToolBarObject);
			var _parentWindow = window.parent.window;
		    if(_parentWindow)
		    {
		       _parentWindow.setToolBar(this.dropDownBakToolBarObject);
			}
			
			UtilActions.updateInnerToolBar(this.dropDownBakToolBarObject);
		    
			return false;	
		}

	}

	buildLookupArg(lookup)
	{
		let lookupAlias = lookup.classAlias;
		if(lookupAlias == "FormModuleLookup" || lookupAlias == "FormLookup")
		{
			lookup.lookupArg = {};
			
			if(this.props.groupAlias!="")
			{
				lookup.lookupArg["groupAlias"] = this.props.groupAlias;	
				var filterFieldName = StringUtil.convertToEachFirstUpperCase(this.props.dataField);
				filterFieldName = filterFieldName.substring(filterFieldName.indexOf(".")+1);
				lookup.lookupArg["baseTableName"] = this.props.group.mainSource.tableName;
				lookup.lookupArg["filterFieldName"] = filterFieldName;
				lookup.lookupArg["baseRecord"] = RecordsUtil.getSecondaryRecord(this.props.rowData?this.props.rowData:this.record,this.props.groupAlias);
				lookup.lookupArg["baseFormId"] = this.props.formId;
			}
			else if(this.props.groupAlias == "")
			{
				lookup.lookupArg["groupAlias"] = null;
				if(this.props.formType!=EditorFormType.FormModule)
				{
					lookup.lookupArg["filterFieldName"] = null;
					lookup.lookupArg["baseFormId"] = null;
				}
				else
				{
					lookup.lookupArg["filterFieldName"] = this.props.xml.name;
					lookup.lookupArg["baseFormId"] = this.props.formId;
				}
				lookup.lookupArg["baseTableName"] = null;
				lookup.lookupArg["baseRecord"] = null;
				
			}
			if(lookup.autoReturn == true)
			{
				let _returnField = lookup.returnField;
				let splitArr = _returnField.split(".");
				let lastField = splitArr[splitArr.length-1];
				lookup.lookupArg["fieldName"] = StringUtil.convertToFirstUpperCase(lastField);
			}
			else
			{
				lookup.lookupArg["fieldName"] = null;
			}
				
			if(this.laterFitlerText)
			{
				_text = this.laterFitlerText;
				this.laterFitlerText = null;
				//用来标记是输入*号导致了下拉
				lookup.lookupArg["asteriskLookupQuery"] = true;	
			}
			else
			{
				var _text = $(this.inputField).val();
			}
			
			if(this.props.queryOnTextChanging == true)
				_text = "*" + _text + "*";
				
			lookup.lookupArg["baseFilter"] = _text;
		}
		else if(lookupAlias == "FormLookupServerAllSpec")
		{
			lookup.lookupArg = {};
			
			if(this.props.groupAlias!="")
			{
				lookup.lookupArg["groupAlias"] = this.props.groupAlias;	
				var filterFieldName = StringUtil.convertToEachFirstUpperCase(this.props.dataField);
				filterFieldName = filterFieldName.substring(filterFieldName.indexOf(".")+1);
				lookup.lookupArg["baseTableName"] = this.props.group.mainSource.tableName;
				lookup.lookupArg["filterFieldName"] = filterFieldName;
				let _baseRecord = this.record;
				if(!_baseRecord && this.props && this.props.rowData)
				{
					_baseRecord = this.props.rowData;
				}
				lookup.lookupArg["baseRecord"] = RecordsUtil.getSecondaryRecord(_baseRecord,this.props.groupAlias);
				lookup.lookupArg["baseFormId"] = this.props.formId;
			}
			else
			{
				lookup.lookupArg["groupAlias"] = null;
				if(this.props.formType!=EditorFormType.FormModule)
				{
					lookup.lookupArg["filterFieldName"] = null;
					lookup.lookupArg["baseFormId"] = null;
				}
				else
				{
					lookup.lookupArg["filterFieldName"] = this.props.xml.name;
					lookup.lookupArg["baseFormId"] = this.props.formId;
				}
				lookup.lookupArg["baseTableName"] = null;
				lookup.lookupArg["baseRecord"] = null;
				
			}
			
			lookup.lookupArg["fieldName"] = null;
			if(this.laterFitlerText)
			{
				_text = this.laterFitlerText;this.laterFitlerText = null;	
			}
			else
			{
				var _text = $(this.inputField).val();
			}
			
			if(this.props.queryOnTextChanging == true)
				_text = "*" + _text + "*";
			
			lookup.lookupArg["baseFilter"] = _text;
		}
		else
		{
			//TODO 目前这种情况有还待测试 
			var filter = {};
			filter["record"] = this.record;
			filter["text"] = $(this.inputField).val();
			lookup.lookupFilter = filter;
		}
		lookup.toolBarObject = this.toolBarObject;
	}

	buildExtralWhereItem(lookup)
	{
		if(this.props.groupAlias!="" && typeof(lookup.setExtralWhereItemValueForRefresh) == "function")
		{
			var filterField = this.props.filterField;
			if(filterField)
			{
				var alias = this.props.groupAlias;
				filterField = StringUtil.convertToFirstLowerCase(filterField);
				var filterfieldvalue = this.record[alias+"."+filterField];
				if(filterfieldvalue && filterfieldvalue != "")
				{
					lookup.setExtralWhereItemValueForRefresh(false,filterfieldvalue);
				}
				else
				{
					// lookup.setExtralWhereItemValueForRefresh(false,"#NULL_FILTER_FIELD#");
					lookup.setExtralWhereItemValueForRefresh(false,"");
				}
			}
		}
		else if(!this.props.groupAlias && typeof(lookup.setExtralWhereItemValueForRefresh) == "function")
		{
			var filterEditorPro = this.props.filterEditor;
			if(filterEditorPro)
			{
				let filterEditor = filterEditorPro.V || filterEditorPro.Value;
				if(!filterEditor)
					return;
				let innerId = filterEditorPro.innerid;

				let arg = {};
				CommandActions.commandArgMapEditors(filterEditor,arg,this.props.moduleInstanceId);

				let filterEditorValue = arg[filterEditor];
				if(filterEditorValue && filterEditorValue != "")
				{
					if(filterEditorValue.indexOf("*")!=-1 || filterEditorValue.indexOf("?")!=-1)
					{
						lookup.setExtralAggregationItemValueForRefresh(false,"Distinct");
						lookup.setExtralWhereItemValueForRefresh(false,filterEditorValue);
					}
					else
					{
						lookup.setExtralWhereItemValueForRefresh(false,filterEditorValue);
					}
				}
				else
				{	//TODO_YL 暂时不添加聚合  2022/11/15
 					//lookup.setExtralAggregationItemValueForRefresh(false,"Distinct");
				}
			}
		}
	}

	getLookupBase()
	{
		var base = {};
		if(this.props.isBoolean == true)
		{
			base["assignedLookup"] = "isBoolean";
		}
		else if(this.props.isEnum == true)
		{
			base["assignedLookup"] = "isEnum";	
		}
		else if(this.props.serverSpecify)//methodarg object
		{
			base["assignedLookup"] = "";
		}
		else
		{
			base["assignedLookup"] = this.props.assignedFormLookup;
		}
		base["entityId"] = this.props.formId;
		base["innerId"] = this.props.xml.id;
		base["componentItemName"] = GOTUtil.getComponentItemName(this.props.dataField);	
		base["editorDataField"] = this.props.dataField?StringUtil.convertToEachFirstUpperCase(this.props.dataField):this.props.xml.name;
		if(this.props.control)
		{
			base["isMainGroup"] = this.props.control.isMainGroup();
			base["refentityid"] = this.props.control.getRefEntityId();
			base["refinnerid"] = this.props.control.getRefInnerId();
		}
		base["formType"] = "FormModule";
		return base;
	}

	showDropDown()
	{
		if(this.lookupStates.isShowed)
		{
			this.closeDropDown();
			return;
		}
		let lookupdiv = this.lookupStates.dropdownform;
		window.lookupShowing = true;
		//暂时把下拉框缓存在项目编辑器实例 由于项目编辑器实例会由reactdatagrid销毁
		//所以缓存对于FormItemStringEditorForDataGrid不适用 应该跟flex一样缓存到全局
		if(lookupdiv==null || !this.lookupStates.lookup)
		{
			if(this.props.dropDownMode == "pop")
			{
				lookupdiv = $("<div>").addClass("modal").css("display","flex").css("align-items","center").css("justify-content","center");
				this.lookupStates.dropdownform = lookupdiv;	
			}
			else
			{
				lookupdiv = $("<div>").css({position:'absolute',padding:'1px',backgroundColor:'#ffffff',border:'solid 1px #d2d2d2',/*float:'left',*/zIndex:800,overflow:'auto'});
				this.lookupStates.dropdownform = lookupdiv;	
			}

			if(this.props.dropDownMode == "pop")
			{
				lookupdiv.appendTo($("#dialogModal"));
			}
			else
			{
				lookupdiv.appendTo($('body'));
			}
			//lookupdiv.show();
		
			var base = {};
			if(this.props.isBoolean == true)
			{
				base["assignedLookup"] = "isBoolean";
			}
			else if(this.props.isEnum == true)
			{
				base["assignedLookup"] = "isEnum";	
			}
			else if(this.props.serverSpecify)
			{
				var fieldName = null;
				let _groupAlias = this.props.groupAlias;
				if(this.props.dataField != null)
				{
					var temp = StringUtil.convertToEachFirstUpperCase(this.props.dataField);
					fieldName = temp.substr(temp.indexOf(".")+1);
				}
				else
				{
					fieldName = this.props.xml.name;
				}

				var mi = this.props.control.getServerSpecify();
				//在自定义下拉框上无该操作
			    var commandArg = CommandResolver.getSendCmd(window.formModuleInstance, this.props.groupAlias, mi);
			    var command = CommandHelper.createFormInstance(window.formModuleInstance.formName, "doOpenLookup","CommandResult")
			      .appendArg(this.props.group?this.props.group.groupAlias:null)
			      .appendArg(fieldName)
				  .appendArg(commandArg, "CommandArg");
			    var _resultHandler = function(data)
			    {
			      	var commandResult = data.result;
			      	var task = commandResult.tasks[0];
					//针对返回空result可能认为没有openlookup  场景：底层有写这个 上层不要想用默认的autolookup效果
					if(!task){
						return;
					}
			      	if(task && task.cmd != Cmd.OpenLookup)
			      	{
			      		alert("openLookup_二次开发方法中只能使用openLookup命令");
			      		return;
			      	}
			      	if(typeof(task.arg) == "string")
			      	{
			      		base["assignedLookup"] = task.arg;
			      	}
			      	else
			      	{
			      		base["formLookup"] = task.arg;
			      	}
					base["fieldName"] = fieldName;	
					base["groupAlias"] = _groupAlias;
			    };
			    var remoteArg = {command:command,resultFunction:_resultHandler};
			    ServiceHelper.addTokenWithCommand(remoteArg);

				/*调用二次开发var commandArg:CommandArg = CommandResolver.getSendCmd(gongqiFormItem.formDesign, group?group.groupAlias:null, serverSpecMI);
				var command:Command = CommandHelper.createFormInstance(gongqiFormItem.formDesign.formModule.formName, "doOpenLookup", "CommandResult")
					.appendArg(group?group.groupAlias:null)
					.appendArg(fieldName)
					.appendArg(commandArg, "CommandArg");
				ServiceHelper.addTokenWithCommand(command,rpc_result_formLookup);*/
				
			}
			else
			{
				base["assignedLookup"] = this.props.assignedFormLookup;
			}
			//base["formType"] = this.formType;
			base["entityId"] = this.props.formId;
			base["editorDataField"] = this.props.dataField?StringUtil.convertToEachFirstUpperCase(this.props.dataField):this.props.xml.name;
			base["innerId"] = this.props.xml.id;
			base["componentItemName"] = GOTUtil.getComponentItemName(this.props.dataField);
			base["minWidth"] = $(this.inputgroup).width();
			base["isPop"] = (this.props.dropDownMode == "pop");
			base["formType"] = "FormModule";
			// if(window.isDataSetView && this.props.xml.Properties.Extends){
			// 	base["extends"] = this.props.xml.Properties.Extends;
			// }
			this.lookupKey = FormLookupFactory.getKey(base);
			var moduleLookup = FormLookupFactory.createFormLookup(base,this.props.dropDownMode);
			//this.moduleLookup = moduleLookup;
			if(!moduleLookup)
				return;
			if(moduleLookup.isCustom)
			{
				this.isCustomDropDown = true;
				var iframe = $("<iframe>").css("border","none").attr("id","iframe"+moduleLookup.formName);
	        	iframe.attr("src","form.html?menuItemId=FormLookup&formId="+moduleLookup.formName+"&lookUp=true&lookUpPop="+base["isPop"]+"&fromEntity="+base["entityId"]+"&fromInnerId="+base["innerId"]);
	        	window.parent.window.$("#noPopLookupForm").append(iframe);
	        	window.parent.window.nowStringEditorInstance = this;
				return;
			}
			// if(window.isDataSetView ){
			// 	window.hasDataSetViewLookup = true;
			// }
			this.lookupStates.lookup = ReactDOM.render(moduleLookup, lookupdiv.get(0));
		}
		
		
		//lookupdiv.css("display","none");
		let lookup = this.lookupStates.lookup;

		this.buildLookupArg(lookup);
		this.buildExtralWhereItem(lookup);

		if(window.isDataSetView ){
			let form = GOT.getForm(this.props.formId);
			let entity = GOTUtil.getFormItemInnerXML(form,this.props.xml.id);
			window.parent.window.lookupEditorDoMain = entity.Properties.doMain;
		}
		LookupActions.lookupRefresh(this.props.formId,this.props.xml.id);

		if(typeof(lookup.queryBoxClear)==="function")
		{
			lookup.queryBoxClear();
		}

		window.nowLookupInstance = lookup;

		var _parentWindow = window.parent.window;
	    if(_parentWindow)
	    {
			this.dropDownBakToolBarObject = Object.assign({},_parentWindow.lastToolBarObject);
	       _parentWindow.setToolBar(this.toolBarObject);
		}
		UtilActions.updateInnerToolBar(this.toolBarObject);
	    if(this.props.dropDownMode == "pop")
	    {
	    	this.lookupStates.isShowed = true;
	    }
	    else
	    {
	    	this.onLookupCmp();
	    }
		if(lookupdiv.hasClass("modal"))
			lookupdiv.css("display","flex");
		else
			lookupdiv.css("display","block");
		this.attachEventListeners();
		//this.setFocusDropDown = true;
		this.inputField.focus();
		return true;
	}

	buttonDownClick(e)
	{
		if(!(
			$(this.inputgroup).is(document.activeElement) || 
			$(this.inputgroup).find(document.activeElement).length	

		))
			e.preventDefault();

		/*let result = {};
		FocusActions.currentGroupGet(result);
		

		if(result.currentGroup != this.props.control.group)
		{
			if(result.currentGroup)
				result.currentGroup.onRecordAutoSave(result.currentGroup.groupAlias);
			if(window.rowChangeAutoSaveFail)
				return;
		}*/
		return this.showDropDown();
	}

	attachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
		this.applyEvents(this.lookupEvents);
	}

	detachEventListeners()
	{
		this.unapplyEvents(this.lookupEvents);
	}

	applyEvents(evs)
	{
		for (var i=0, el, ch, ev; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.on(ev, ch);
		}
	}

	unapplyEvents(evs)
	{
		for (var i=0, el, ev, ch; i < evs.length; i++)
		{
			el = evs[i][0];
			if (evs[i].length === 2){
				ch = undefined;
				ev = evs[i][1];
			}
			else if (evs[i].length === 3){
				ch = evs[i][1];
				ev = evs[i][2];
			}
			el.off(ev, ch);
		}
	}

	onBeforeAutoSave(groupAlias,results)
	{
		if(this.props.groupAlias != groupAlias)
			return true;
		if($(this.inputField).is(document.activeElement) || $(this.inputField).find(document.activeElement).length)
		{
			var text = $(this.inputField).val();
			var _val = FormItemStringResolver.getResult(text,this.props.trim,this.props.changeCase,this.props.stringSize,this.props.regular);
			if(_val.indexOf(FormItemStringResolver.RESOLVER_FALSE_TAG) == 0)
			{
				return false;
			}
			if(this.props.groupAlias == "")
			{
				this.record = _val;
			}
			else
			{
				let changed = false;
				let oldValue = this.record[this.props.dataField];
				let newValue = _val;
				if(oldValue != newValue)
					changed = true;
				this.record[this.props.dataField] = newValue;
				//alert("派发");	
				if(changed)	
				{
					RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
					if(this.props.control)
					{
						let result = this.props.control.doFieldModifiedRemote(this.props.dataField,newValue,oldValue,this.record,this);
						if(results)results.put(result);
					}
						
				}
				this.updateModifiedTag();		
			}
		}
		return true;
		
	}

	setFinalValue(value,triggerModified = true)
	{
		if(value=='-点此填值-'){
			$(this.inputField).val('');
			value='';
		}
		if(value == null || value == undefined)
			value = $(this.inputField).val();

		value = FormItemStringResolver.getResult(value,this.props.trim,this.props.changeCase,this.props.stringSize,this.props.regular);
		if(value.indexOf(FormItemStringResolver.RESOLVER_FALSE_TAG) == 0)
		{
			Warning.show({text:value.substr(FormItemStringResolver.RESOLVER_FALSE_TAG.length)});
			return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
		}
		if(!this.props.dataField)
		{
			var oldValue = this.record;
			if(this.props.stringSize && this.props.stringSize>0 && this.props.stringSize < value.length){
				Warning.show({text: "字段："+this.props.label+' 所输入内容超出字段设定长度 '+this.props.stringSize +" 请重新输入！！" });
			}
			this.record = value;
			if(this.props.groupAlias == "" || !this.props.groupAlias)
			{
				var newValue = value;this.record = value;
				if(this.props.control && oldValue != newValue && triggerModified)
				{
					if(this.state.underQueryGroup)
					{
						//TODO 在QueryGroup下的时候 此处如果返回命令中存在wirteEditor到别的文本框
						//会导致当前文本框失去焦点并写入空值  而此时还没有进行setDisplay回显 所以加个延迟
						let control = this.props.control;
						setTimeout(function(){control.doModifiedEditor(oldValue, newValue,this);},100);
					}
					else
					{
						this.props.control.doModifiedEditor(oldValue, newValue,this);
					}
				}
			}
		}
		else
		{
			if(!this.record)
				return FormItemConst.EDITOR_VALUE_CHANGED_ERROR;
			let changed = false;
			let oldValue = (this.record&&this.props.dataField)?this.record[this.props.dataField]:(this.record?this.record:"");
			let newValue = value;
			if(oldValue != newValue)
				changed = true;



				if(this.props.stringSize && this.props.stringSize>0 && this.props.stringSize < newValue.length){
					Warning.show({text: "字段："+this.props.label+' 所输入内容超出字段设定长度 '+this.props.stringSize +" 请重新输入！！" });
				}

				this.record[this.props.dataField] = newValue;
			//alert("派发");	
			if(changed)	
			{
				RecordsActions.RecordFieldChanged(this.record,this.props.dataField,oldValue,newValue,this);
				if(this.props.control)this.props.control.doFieldModifiedRemote(
			    		this.props.dataField,newValue,oldValue,null,this
			    );
			}
			this.updateModifiedTag();		
		}
		return FormItemConst.EDITOR_VALUE_CHANGED_SUC;
	}

	restoreValue(_value)
	{
		if(!this.props.dataField)
		{
			this.record = _value;
		}
		else if(this.record)
		{
			this.record[this.props.dataField] = _value;
		}
		this.setDisplay();
		this.updateModifiedTag();
	}

	inputFieldBlur()
	{
		if(this.lookupStates.isShowed)
			return;
		
		//console.log("失去焦点");
		if(this.state.underQueryGroup){
			var reg = "^[ ]+$";
			var rege = new RegExp(reg);
			if(rege.test($(this.inputField).val())){
				$(this.inputField).val('-只查空值-');
				this.record = '-只查空值-';
				this.state.nullValue = true;
				this.inQueryGroup = true;
			}else{
				if($(this.inputField).val()==''){
					this.setState({allowEdit:false,nullValue:false})
					this.inQueryGroup = false;
				}else{
					this.inQueryGroup = true;
				}
			}
			this.state.notNull = false;
		}
		if(this.props.control && this.props.control.getProperty_AllowEdit_Final() == true)
		{
			this.setFinalValue();
			//todo 值回送数据完成以后 严格按照显示要求再进行显示
			this.setDisplay();

			//this.getInputMsg();
		}
		if(this.holdFocus)
		{
			var $inputField = $(this.inputField);
			//setTimeout(function(){$inputField.focus();}, 0);
			$(window).focus();
			$(this.inputField).focus();
			$(this.inputField).select();
		}
	}
	
	
	setDisplay(value)
	{
		if(value == null || value == undefined)
		{
			if(this.props.dataField && this.record)
				value = this.record[this.props.dataField];
			else
				value = this.record;
		}
		$(this.inputField).val(value);
	}
	inputContentFocus(){
		$(this.inputField).focus();
		$(this.inputField).select();
	}
	inputContentBlur(){
		if(this.props.underQueryGroup){
			this.setState({allowEdit:false})
		}
	}
	inputFieldFocus()
	{
		//alert(this.props.label+"触发了");
		if(window.rowChangeAutoSaveFail==true)
			return;
		window.lastFocusUI = this.inputField;
		if(this.props.groupAlias)
			window.lastEditedDataFields[this.props.groupAlias] = this.props.dataField;
		if(this.onLookupReturning == true)
			return;
		FocusActions.currentGroupSet(this.props.groupAlias,this.props.formId);
		//alert('focus');
		if(window.rowChangeAutoSaveFail==true)
			return;
		if(!this.props.dataField)
		{

			$(this.inputField).val(this.record);
		}
		else
		{
			let _recordValue = this.record==null?"":this.record[this.props.dataField];
			$(this.inputField).val(_recordValue);	
		}
		if(this.state.underQueryGroup){
			if($(this.inputField).val() == '-只查空值-'){
				$(this.inputField).val('');
				this.record='';
			}
		}

		if(this.state.displayHeight < 2)
		{
			let _parentWindow =window;	
			if(_parentWindow.notClickFocusEditor){
				_parentWindow =window;
			}else if(window.parent.window.notClickFocusEditor){
				_parentWindow =window.parent.window;
			}
			if(_parentWindow.notClickFocusEditor == undefined || (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors == '')
				|| (!_parentWindow.notClickFocusEditor.allNotFocus && _parentWindow.notClickFocusEditor.editors.indexOf(this.inputField.parentElement.parentElement.id) == -1 )){
				$(this.inputField).select();
			}
		}
			
	}

	inputFieldDbClick()
	{
		$(this.inputField).select();
		if(this.props.underQueryGroup){
			this.setState({allowEdit:true,nullValue:false})
		}
	}
	inputFieldOnClick(){
		if(this.props.underQueryGroup){
			this.state.notNull = false
			this.setState({allowEdit:true,nullValue:false})
			this.inQueryGroup = true;
		}
	}
	inputCloseOnClick(){
		$(this.inputField).val('');
		this.record='';
		this.setState({allowEdit:false,nullValue:false})
		this.inQueryGroup = false;
	}

	textOnChange(e)
	{
		this.state.nullValue = false
		let nowTxt = $(this.inputField).val();
		if(!this.props.queryOnTextChanging)
		{
			//alert(FormItemConst.WILDCARD);
			if(nowTxt.indexOf(FormItemConst.WILDCARD)!=-1)
			{
				let _id = CommonUtil.delayFunc(500,this,this.doAsteriskRefresh,nowTxt);
			}
		}
		else
		{
			CommonUtil.delayFunc(1000,this,this.queryOnTypingSlow,nowTxt);
		}
		//LookupActions.lookupRefresh(this.props.formId,this.props.xml.id);
	}

	queryOnTypingSlow(historyText)
	{
		if($(this.inputField).val() == historyText)
		{
			if(historyText.indexOf(FormItemConst.WILDCARD)==-1)
				historyText = FormItemConst.WILDCARD+historyText+FormItemConst.WILDCARD;
			if(this.lookupStates.isShowed)
			{
				LookupActions.lookupasteriskRefresh(this.props.formId,this.props.xml.id,historyText);
			}
			else
			{
				this.showDropDown();
			}
		}
	}

	doAsteriskRefresh(historyText)
	{
		if($(this.inputField).val() == historyText)
		{
			//如果一个星号的话 跟原来一样 如果有两个星号 分四种情况 **xxx-->*xxx*  xxx**-->*xxx*  xx**xx-->*xx*xx*  ***->* 四种情况已测
			let result = historyText;
			let dtag = FormItemConst.WILDCARD+FormItemConst.WILDCARD;
			let flag  = false;let dindex = result.indexOf(dtag);
			if(dindex!=-1)
			{
				let reg = new RegExp("[\\"+FormItemConst.WILDCARD+"]{2,}","g");
				result = result.replace(reg,FormItemConst.WILDCARD);
				//result = result.replace(/[\*]{2,}/g,"*");//2个及以上替换成一个
				if(result.charAt(0)!=FormItemConst.WILDCARD)result = FormItemConst.WILDCARD+result;
				if(result.charAt(result.length-1)!=FormItemConst.WILDCARD)result = result+FormItemConst.WILDCARD;
			}
			
			if(this.lookupStates.isShowed)
			{
				LookupActions.lookupasteriskRefresh(this.props.formId,this.props.xml.id,result);
			}
			else
			{
				this.laterFitlerText = result;
				this.showDropDown();
			}
		}
		else
		{

		}
	}

	onLookupDropDownClose(formId,innerId)
	{
		if(this.props.formId == formId && this.props.xml.id == innerId)
		{
			this.closeDropDown();
		}
	}

	onKeyDownHandler(e)
	{
		if(13 == e.keyCode && this.lookupStates.isShowed)
		{
			return;
		}
		if(13 == e.keyCode && this.state.displayHeight>1 && this.state.allowEdit)
		{
			let keyboardArg = this.props.control?this.props.control.propertyKeyDownEvent:null;
			if(keyboardArg)
			{
				for(let i = 0;i<keyboardArg.keyCodeArgs.length;i++)
				{
					let keyCodeArg = keyboardArg.keyCodeArgs[i];
					if(keyCodeArg.ctrlKey==e.ctrlKey && keyCodeArg.shiftKey==e.shiftKey && (keyCodeArg.keyCode==e.keyCode || keyCodeArg.keyCode == e.charCode))
					{
						e.preventDefault();
						let callBackArg = {remoteClass:"gongqi.erp.gotmodel.form.remote.KeyCodeResult"};
						callBackArg.ctrlKey = e.ctrlKey;
						callBackArg.shiftKey = e.shiftKey;
						callBackArg.keyCode = e.keyCode;
						setTimeout(this.doKeyBoardServer.bind(this),1000,callBackArg);
					}	
				}
			}
			return;
		}
		if(super.onKeyDownHandler(e))
			return;
		if(40===e.keyCode || 38===e.keyCode)
		{
			//let ne = e["nativeEvent"];
			if(this.lookupStates.isShowed)
			{
				e.preventDefault();
				e.stopPropagation();
				if(e.ctrlKey && e.keyCode == 38)
				{
					this.closeDropDown();
				}
				else
				{
					LookupActions.lookupHostKeydown(this.lookupKey,e);	
				}
				
			}
			else if(e.ctrlKey && e.keyCode == 40)
			{
				e.preventDefault();
				e.stopPropagation();
				if($(this.downArrowButton).is(":visible"))
					this.showDropDown();
			}
			
		}
		else if(13 == e.keyCode && this.lookupStates.isShowed)
		{
			e.preventDefault();
			e.stopPropagation();
			LookupActions.lookupHostKeydown(this.lookupKey,e);	
		}
		else if(27 == e.keyCode && this.lookupStates.isShowed)
		{
			e.preventDefault();
			e.stopPropagation();
			this.closeDropDown();
		}
		else if(!this.props.allowKeyIn)
		{
			e.preventDefault();
			e.stopPropagation();
			return;
		}
	}

	onCmdUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		let result = super.onCmdUpdateControlProperty(name,property,value,moduleInstanceId);
		if(name != this.props.xml.name || this.props.moduleInstanceId != moduleInstanceId)
			return;
		if(property == ControlPropertyConst.IMEENABLE)
		{
			this.setState({imeEnabel:value});return true;
		}
		return false;
	}

	onFocusSet(formId,itemId,pre,init)
	{
		if(this.props.formId == formId && this.props.xml.id == itemId)
		{
			if(this.state.displayHeight>1)
			{
				let that = this;
				setTimeout(function(){
					$(that.inputField).focus();
					that.inputField.setSelectionRange(0,0);
				},200);
				
			}
			else
			{
				let that = this;
				setTimeout(function(){
					$(that.inputField).focus();
					$(that.inputField).select();
				},200);
			
			}
		}
	}


	getTextAreaDom(displayHeight)
	{
		let _style = {resize:'none',padding:'2px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR};
		if(this.state.allowEdit)
		{
			 _style = {resize:'none',padding:'2px'};
				let heightProValue = this.props.control.getProperty_Height();//heightProValue = "100%";
				if(heightProValue == "100%")_style.height = "100%";
				if(heightProValue)_style.height = heightProValue+"px";
				if(this.props.cssStyle)
				{
					Object.assign(_style,this.props.cssStyle);
				}
				if(this.state.color && this.state.color != -1)_style.color = this.state.color;
				if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
				if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
				if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
				if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
				if(!this.state.imeEnabel)_style.imeMode = 'disabled';
				if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
				 return	<textarea spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id}
							   className="form-control" rows={displayHeight}  style={_style} onKeyDown={this.onKeyDownHandler.bind(this)}
							   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)} 
							  ></textarea>
			
		}
		else
		{
		
				let heightProValue = this.props.control.getProperty_Height();
				if(heightProValue)_style.height = heightProValue+"px";
				if(this.props.cssStyle)
				{
					Object.assign(_style,this.props.cssStyle);
				}
				if(this.state.color && this.state.color != -1)_style.color = this.state.color;
				if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
				if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
				if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
				if(!this.state.imeEnabel)_style.imeMode = 'disabled';
				if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
				 return	<textarea spellCheck="false" autoComplete="off" ref={node => this.inputField = node} id={"input"+this.props.xml.id}  readOnly="readonly" 
							   className="form-control" rows={displayHeight}  style={_style} onKeyDown={this.onKeyDownHandler.bind(this)}
							  onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}
							 ></textarea>
		

		}
	}

	getInputDom(_width)
	{
		if(this.state.allowEdit)
		{
			let _style = {padding:'2px',paddingRight:'13px',height:(this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT)+'px',fontSize:"12px",width:_width};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.state.dropDownNumKeyBoard){
				_style.paddingRight='24px'
			}
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(!this.state.imeEnabel)_style.imeMode = 'disabled';
			let _type = this.props.control.getDisplayAsPassword()?"password":"text";
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);
			let helpText = this.props.control.getProperty_HelpText();
			if(this.props.underQueryGroup){
				if(this.props.initRecord &&  typeof(this.props.initRecord) =='string') {
					let defaultValue = this.props.initRecord ;
					if(this.hasLookup){
						_style.paddingRight='24px'
						return	<div style={{position:'relative',width:'100%',height:'100%'}}  >
						<input title={helpText} spellCheck="false" autoComplete="off" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue} />
							<i className="fa fa-times-circle" style={{position: 'absolute',right: '12px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>
						</div>	
					}else{
					return	<div style={{position:'relative',width:'100%',height:'100%'}}  >
						<input title={helpText} spellCheck="false" autoComplete="off" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue} />
							<i className="fa fa-times-circle" style={{position: 'absolute',right: '3px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>
						</div>	
					}

				}else{

					// onFocus={this.inputContentFocus.bind(this)} onBlur={this.inputContentBlur.bind(this)}
					if(this.hasLookup){
						_style.paddingRight='24px'
					return	<div style={{position:'relative',width:'100%',height:'100%'}} >
						<input title={helpText}  ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
						onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
						onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)} />
							<i className="fa fa-times-circle" style={{position: 'absolute',right: '12px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
					</div>
					}else{
						return	<div style={{position:'relative',width:'100%',height:'100%'}} >
						<input title={helpText}  ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
						onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
						onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)} />
							<i className="fa fa-times-circle" style={{position: 'absolute',right: '3px',top:'5px',zIndex:'1000',color:'gray',fontSize:'1px'}} onClick={this.inputCloseOnClick.bind(this)}></i>	
					</div>
					}
				}

			}else{
				if(this.props.initRecord &&  typeof(this.props.initRecord) =='string') {
					let defaultValue = this.props.initRecord ;
					return	<input title={helpText} spellCheck="false" autoComplete="off" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue}/>;	
				}else{
					return	<input title={helpText} spellCheck="false" autoComplete="off" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type={_type}  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					onChange={this.textOnChange.bind(this)} onDoubleClick={this.inputFieldDbClick.bind(this)}/>;	
				}
			}
		}
		else
		{
			let _style = {padding:'2px',paddingRight:'13px',height:(this.props.height?this.props.height:FormItemConst.EDITOR_HEIGHT)+'px',backgroundColor:FormItemConst.EDITOR_NOTEDIT_COLOR,fontSize:"12px",width:_width};
			_style.textAlign = this.props.textAlign.toLowerCase();
			if(this.state.dropDownNumKeyBoard){
				_style.paddingRight='24px'
			}
			if(this.props.cssStyle)
			{
				Object.assign(_style,this.props.cssStyle);
			}
			if(this.state.color && this.state.color != -1)_style.color = this.state.color;
			// TODO_YL 修改  根据 bindStyle 命令 改变 不可编辑字段的背景颜色
			if(this.state.backgroundColor && this.state.backgroundColor != -1)_style.backgroundColor = this.state.backgroundColor;
			
			if(this.state.fontSize && this.state.fontSize != -1)_style.fontSize = this.state.fontSize;
			if(this.state.fontFamily)_style.fontFamily = this.state.fontFamily;
			if(this.state.fontWeight)_style.fontWeight = this.state.fontWeight;
			if(!this.state.imeEnabel)_style.imeMode = 'disabled';
			if(this.props.customStyle)Object.assign(_style,this.props.customStyle);

			if(this.props.underQueryGroup){

				if(this.props.initRecord &&  typeof(this.props.initRecord) =='string') {
					var defaultValue = this.props.initRecord;
					return	<div><input spellCheck="false" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type="text"  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					readOnly="readonly" autoComplete="off" onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue} onClick={this.inputFieldOnClick.bind(this)}/>
					</div>
				}else{
					_style.textAlign='center';
					var defaultValue = "-点此填值-";
					return	<div><input spellCheck="false" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type="text"  style={_style}
									   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
									   readOnly="readonly" autoComplete="off" onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue} onClick={this.inputFieldOnClick.bind(this)} />
									   </div>
									}
			}else{
				if(this.props.initRecord &&  typeof(this.props.initRecord) =='string') {
					var defaultValue = this.props.initRecord;
					return	<input spellCheck="false" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type="text"  style={_style}
					onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
					readOnly="readonly" autoComplete="off" onDoubleClick={this.inputFieldDbClick.bind(this)} value={defaultValue}/>;
					
				}else{
					return	<input spellCheck="false" ref={node => this.inputField = node} className="form-control" id={"input"+this.props.xml.id} type="text"  style={_style}
									   onBlur={this.inputFieldBlur.bind(this)} onFocus={this.inputFieldFocus.bind(this)}  onKeyDown={this.onKeyDownHandler.bind(this)}
									   readOnly="readonly" autoComplete="off" onDoubleClick={this.inputFieldDbClick.bind(this)} />;
				}

			}

		}
	}

	showNumKeyBoard()
	{
		var _offset1 = $(this.inputField).offset();
		var _offset2 = $(window.frameElement).offset();
		var _inputwidth = $(this.inputField).width();
		var _inputheight = $(this.inputField).height()+7;
		window.parent.window.showNumKeyBoard("clear",_offset1,_offset2,_inputwidth,_inputheight,this.calculatorReturnHandler.bind(this));

		$(window.parent.document).find("#jqcalculator_percentage").css('display','block');
		$(window.parent.document).find("#jqcalculator_decimal").css('display','block');

	}

	calculatorReturnHandler(result)
	{
		if(result && this.state.allowEdit)
		{
			this.setFinalValue(result);
			//值回送数据完成以后 严格按照显示要求再进行显示
			this.setDisplay();
		}

		$(this.inputField).focus();
		$(this.inputField).select();
	}

	getDownArrowButtonDom()
	{

		// if(this.state.dropDownNumKeyBoard)
		// {
		// 	if(this.state.allowEdit)
		// 		return <i ref={node => this.downArrowButton = node} onMouseDown={this.showNumKeyBoard.bind(this)} className="fa fa-keyboard-o"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
		// 	else
		// 		return null;
		// }

		if(this.state.allowEdit && this.hasLookup)
		{
			/*return	({has:true,dom:<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 4px 4px'}}  onMouseDown={this.buttonDownClick.bind(this)}>
	        			<i className="fa fa-sort-desc"></i>
					</span>});*/

					if(this.state.dropDownNumKeyBoard){

						return	({has:true,dom:<i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 24px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>});
					}else{

						return	({has:true,dom:<i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>});
					}
		}
		else if(!this.state.allowEdit && this.hasLookup)
		{
			/*return	({has:false,dom:<span ref={node => this.downArrowButton = node} className="input-group-addon" style={{cursor:'pointer',height:'22px',padding:'1px 4px 4px',display:"none"}}  onMouseDown={this.buttonDownClick.bind(this)}>
	        			<i className="fa fa-sort-desc"></i>
					</span>});*/
					if(this.state.dropDownNumKeyBoard){
						return	({has:false,dom:<i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 24px)',fontSize:'11px',cursor:'pointer',display:'none',zIndex:3}}></i>});
					}else{

						return	({has:false,dom:<i ref={node => this.downArrowButton = node} onMouseDown={this.buttonDownClick.bind(this)} className="fa fa-sort-desc"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 11px)',fontSize:'11px',cursor:'pointer',display:'none',zIndex:3}}></i>});
					}
		}

		return undefined;
	}
	getNumKeyBoardDom()
	{
		if(this.state.dropDownNumKeyBoard)
		{
			if(this.state.allowEdit)
				return <i ref={node => this.downArrowButtonNum = node} onMouseDown={this.showNumKeyBoard.bind(this)} className="fa fa-keyboard-o"  style={{position:'absolute',top:'calc(100% / 2 - 7px)',left:'calc(100% - 13px)',fontSize:'11px',cursor:'pointer',zIndex:3}}></i>;
			else
				return null;
		}
	}

	render()
	{
		//let inputgroupWidth = this.props.displayLengthWidth+"px";
		let _display = this.currentDataFieldChanged?"block":"none";
		let displayHeight=this.state.displayHeight;
		let displayLength=this.state.displayLength;

		let _width=displayLength*FormItemConst.displayLength_EN+FormItemConst.displayLength_ENAddon;
		let notNull=this.state.notNull;
		var _notNullStyle={};
		_notNullStyle['fontSize']='8px';
    	_notNullStyle['color']='red';
		if(!notNull){
			_notNullStyle['visibility']='hidden';
		}else if(this.props.underQueryGroup){
			_notNullStyle['visibility']='hidden';
		}
		let editorStyle = {display:'flex',flexShrink:0,flexDirection:'row',alignItems:'center'};
		if(this.state.visible == false)
			if(this.state.hideInVisible == true) editorStyle.display="none"; else editorStyle.visibility="hidden";
			
			// _notNullStyle['display']='none';
		if(displayHeight>1){
			let textAreaDom = this.getTextAreaDom(displayHeight);
			let downArrowButtonDomObj = this.getDownArrowButtonDom();
			let downArrowButtonDom = downArrowButtonDomObj?downArrowButtonDomObj.dom:downArrowButtonDomObj;
			let keyborddom = this.getNumKeyBoardDom();
			let widthProValue = this.props.control.getProperty_Width();
			let heightProValue = this.props.control.getProperty_Height();
			//widthProValue = "100%";heightProValue = "100%";
			let inputgroupStyle = {width:_width+"px"};

			if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
			{
				inputgroupStyle.width = widthProValue;editorStyle.width = "100%";
			}

			//if(widthProValue == "100%"){editorStyle.width = "100%";inputgroupStyle.width = "100%"}
			if(heightProValue == "100%"){editorStyle.height = "100%";inputgroupStyle.height = "100%"}
			let labelStyle={paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'}
			if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"}
			return(
				<div id={this.props.xml.name} ref={node => this.element = node} className='editorGroup' style={editorStyle}>
					<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
						style={labelStyle}>
						{this.state.label}
						
					</label><i className='fa fa-snowflake-o' style={_notNullStyle}></i>
					<div className="input-group" ref={node=>this.inputgroup=node} style={inputgroupStyle}>
				       	{textAreaDom}{downArrowButtonDom}{keyborddom}
				        <i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}} alt="已修改"></i>
				    </div>
				</div>
			);
		}else{
			
			let downArrowButtonDomObj = this.getDownArrowButtonDom();
			let downArrowButtonDom = downArrowButtonDomObj?downArrowButtonDomObj.dom:downArrowButtonDomObj;
			let widthProValue = this.props.control.getProperty_Width();
			let middleStyle = {};
			if(widthProValue && widthProValue.indexOf && widthProValue.indexOf("%") != -1)
			{
				_width = "100%";middleStyle.width = widthProValue;editorStyle.width = "100%";
			}
			else
			{
				_width+="px";
			}
			let inputdom = this.getInputDom(_width);
			let keyborddom = this.getNumKeyBoardDom();
			/*if(this.hasLookup && this.state.allowEdit)//有下拉框并且可编辑的情况下
				inputdom = this.getInputDom(_width-18+'px');
			else
				inputdom = this.getInputDom(_width+'px')
			let inputgroupWidth = _width;*/
			
			let labelStyle={paddingLeft:'5px',width:'auto',textAlign:'right',whiteSpace:'nowrap',marginBottom:'0px'};
			// if(this.state.underQueryGroup)
			// {
			// 	labelStyle.cursor = "pointer";
			// 	if(!this.inQueryGroup && !this.props.underQueryGroup)
			// 		labelStyle.color = "#CFCFCF";
			// }
			if(!this.state.label){labelStyle.display = "none";_notNullStyle.display = "none"}
			return(
				<div id={this.props.xml.name} ref={node => this.element = node} className='editorGroup' style={editorStyle}>
					<label htmlFor={"input"+this.props.xml.id} className="fieldGroupLabel" ref={node => this.componentLabel = node}
						style={labelStyle} onClick={this.labelClickHandler.bind(this)}>
						{this.state.label}
					</label>
					<i className='fa fa-snowflake-o' style={_notNullStyle}></i>
					<div className="input-group" ref={node=>this.inputgroup=node} style={middleStyle}>
				        {inputdom}{downArrowButtonDom}{keyborddom}
				        <i ref={node => this.modifiedTag = node} className="fa fa-sort-asc" aria-hidden="true" style={{color:"red",position:"absolute",top:"-5px",right:"-3px",fontSize:"11px",transform:'rotate(45deg)',zIndex:"100",marginRight:'4.5px',marginTop:'4px',display:_display}}></i>
				    </div>
				</div>
			);
		}
		
		
	}
}



// WEBPACK FOOTER //
// ./src/formItem/FormItemStringEditor.js